<template>
  <div class="box5">
    <div class="text">
      就行业而言，平均10年才能成为一名可靠的技术开发人员
      <p>但程序员的职业黄金期很短，因此晋升成长急不可待</p>
    </div>

    <div class="content">
      <p>在博学谷，突破职业瓶颈，成为Java架构师仅需要6个月</p>因为课程内容精，所以学习速度快
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.box5 {
  // padding: 80px 0;
  padding-top: 63px;
  width: 100%;
  height: 446px;
  background: url("../../../assets/coursePage/architect/box5/box5-bg.png")
    no-repeat;
  text-align: center;
  background-size: cover;
  background-position-x: center;

  .text {
    font-family: PingFang SC;
    p {
      font-weight: bold;
    }
    font-size: 26px;
    font-weight: normal;

    line-height: 48px;
    letter-spacing: 0px;
    color: #ffffff;
    text-shadow: 2px 3px 10px rgba(0, 0, 0, 0.3);
  }

  .content {
    margin-top: 30px;
    padding-top: 70px;
    width: 100%;
    height: 233px;
    background: url("../../../assets/coursePage/architect/box5/content.png")
      no-repeat;
    background-size: cover;
    box-sizing: border-box;

    font-family: PingFang SC;
    font-size: 26px;
    font-weight: bold;

    line-height: 52px;
    letter-spacing: 0px;
    color: #ffffff;
    p {
      font-weight: normal;
    }
  }
}
</style>